import {GvfService} from "./gvf-service";

export class Component{
    /**
     * Creates a new component
     * @param {string} scope
     * @param {jQuery} $root
     */
    constructor(scope,$root){
        this.scope = scope;
        this.$root = $root;
        this.$root.data("component",this);
        this._requests = [];
        this._intervals = [];
    }

    toJSON(){ //avoid conversions to json
        return undefined;
    }

    /**
     * Gets member based on scope
     * @param {string|string[]} memberClass Class name after [scope]__
     * @returns {jQuery}
     */
    findMember(memberClass){
        if(this.$root){
            let selector = this.scope+"__"+memberClass;
            if($.isArray(memberClass)){
                let l = [];
                for(let i in memberClass){
                    l.push(this.scope+"__"+memberClass[i]);
                }
                selector = l.join(",");
            }
            return this.$root.find(selector);
        }else{
            throw "Component is not ready yet";
        }
    }

    /**
     * Applies binding action to current component
     * @param {string} action
     * @param {any} binding
     */
    applyBindingAction(action,binding){
        switch(action){
            case "show":
            case "hide":
                this.$root.toggle(action=="show");
                break;
        }
    }

    /**
     * Tracks an endpoint call so it can be aborted on destroy
     * @param {string} path
     * @param {Object} params
     * @param {string?} method
     * @returns {Promise}
     */
    endpoint(path, params, method){
        const promise = GvfService.endpoint(path, params, method);
        this._requests.push(promise);
        const cleanup = () => { this._requests = this._requests.filter(r => r !== promise); };
        promise.then(cleanup, cleanup);
        return promise;
    }

    /**
     * Tracks a setInterval so it is cleared on destroy
     * @param {number} id
     * @returns {number}
     */
    trackInterval(id){
        this._intervals.push(id);
        return id;
    }

    /**
     * Aborts all tracked endpoint requests and clears tracked intervals
     */
    destroy(){
        this._requests.forEach(p => p.abort?.());
        this._requests = [];
        this._intervals.forEach(id => clearInterval(id));
        this._intervals = [];
    }

    ready(){
        //component level ready function
    }
}

//extends jquery for component method
jQuery.fn.extend(
    {
        /**
         * @returns {Component}
         */
        "component": function(){
            return this.data("component");
        }
    }
);